module.exports = __webpack_public_path__ + "static/media/postypost.589752fd.png";